import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@repo/design-system-kit/components/button/button';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import errorLottie from '@repo/visual-assets/dotlottie/lottie_pop_general_error404.lottie';
import cx from 'clsx';
import style from './qes.module.css';

interface QesErrorProps {
  retry: () => void;
  hasSpinner?: boolean;
}

export function QesError({ retry, hasSpinner }: QesErrorProps): ReactNode {
  return (
    <div className={style.wrapper} data-test-fourthline-error-qes>
      <LottiePlayer
        className={cx('mb-32', style.errorIllustration)}
        data-test-fourthline-error-qes-illustration
        loop={false}
        src={errorLottie}
      />
      <h1 className="heading-section mb-16" data-test-fourthline-error-qes-title>
        <FormattedMessage id="fourthline.errors.qes-failed.title" />
      </h1>
      <p className="body-standard mb-32" data-test-fourthline-error-qes-subtitle>
        <FormattedMessage id="fourthline.errors.qes-failed.subtitle" />
      </p>
      <Button
        data-test-fourthline-error-qes-cta
        isPending={hasSpinner}
        onPress={retry}
        variant="primary"
      >
        <FormattedMessage id="fourthline.errors.qes-failed.cta" />
      </Button>
    </div>
  );
}
